import { inject, Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import { NavController } from '@ionic/angular';

export const NAVIGATIONURLS = {
	tos: () => 'tos',
	faq: () => 'faq',
	map: () => 'map',
	mapVenue: (venueId?: string) => `map/${venueId}`,
	home: () => 'home',
	menu: () => 'menu',
	order: () => 'order',
	signIn: () => 'sign-in',
	signUp: () => 'sign-up',
	privacy: () => 'privacy',
	promo: () => 'promotions',
	privacyApp: () => 'privacy-app',
	allInfo: () => 'account',
	settings: () => 'settings',
	account: () => 'user-data',
	myOrders: () => 'my-orders',
	impressum: () => 'impressum',
	accessibilityStatement: () => 'barrierefreiheit',
	foodSpot: () => 'food-spot',
	maintenance: () => 'maintenance',
	emailAction: () => 'email-action',
	paymentFail: () => 'payment/failed',
	confirmEmail: () => 'confirm-email',
	paymentCancel: () => 'payment/cancel',
	paymentSuccess: () => 'payment/success',
	selectCategory: () => 'select-category',
	selectOrderType: () => 'select-order-type',
	paymentFailPaymentId: (paymentId?: string) => `payment/failed/${paymentId}`,
	paymentCancelPaymentId: (paymentId?: string) => `payment/cancel/${paymentId}`,
	paymentSuccessPaymentId: (paymentId?: string) => `payment/success/${paymentId}`,
};
export const navPaymentSuccess = async (router: Router, order: string, payment: string) => {
	await router.navigate([NAVIGATIONURLS.paymentSuccessPaymentId(payment)], {
		queryParams: {
			order,
		},
	});
};
@Injectable({
	providedIn: 'root',
})
export class NavigationService {
	router = inject(Router);
	private navCtrl = inject(NavController);
	constructor() {}

	async menu() {
		await this.router.navigateByUrl(NAVIGATIONURLS.menu(), { replaceUrl: true });
	}

	async home() {
		await this.router.navigateByUrl(NAVIGATIONURLS.home());
	}

	async order(largeScreen = false) {
		return this.router.navigateByUrl(largeScreen ? NAVIGATIONURLS.menu() : NAVIGATIONURLS.order());
	}

	async imprint() {
		await this.router.navigateByUrl(NAVIGATIONURLS.impressum());
	}

	async accessibility() {
		await this.router.navigateByUrl(NAVIGATIONURLS.accessibilityStatement());
	}

	async paymentSuccess(order: string, payment: string) {
		await this.router.navigate([NAVIGATIONURLS.paymentSuccessPaymentId(payment)], {
			queryParams: {
				order,
			},
		});
	}
	async paymentError(order: string, payment: string) {
		await this.router.navigate([NAVIGATIONURLS.paymentFailPaymentId(payment)], {
			queryParams: {
				order,
			},
		});
	}
	async cancelError(order: string, payment: string) {
		await this.router.navigate([NAVIGATIONURLS.paymentCancelPaymentId(payment)], {
			queryParams: {
				order,
			},
		});
	}
	async maintenance() {
		await this.router.navigateByUrl(NAVIGATIONURLS.maintenance(), {
			skipLocationChange: true,
			replaceUrl: false,
		});
	}
	async faq() {
		await this.router.navigateByUrl(NAVIGATIONURLS.faq());
	}
	async tos() {
		await this.router.navigateByUrl(NAVIGATIONURLS.tos());
	}
	async signUp() {
		await this.router.navigateByUrl(NAVIGATIONURLS.signUp());
	}
	async signIn() {
		await this.router.navigateByUrl(NAVIGATIONURLS.signIn());
	}
	async myOrders() {
		await this.router.navigateByUrl(NAVIGATIONURLS.myOrders());
	}
	async account() {
		await this.router.navigateByUrl(NAVIGATIONURLS.account());
	}
	async allInfo() {
		await this.router.navigateByUrl(NAVIGATIONURLS.allInfo());
	}
	async privacy() {
		await this.router.navigateByUrl(NAVIGATIONURLS.privacy());
	}
	async privacyApp() {
		await this.router.navigateByUrl(NAVIGATIONURLS.privacyApp());
	}
	async emailConfirmation() {
		await this.router.navigateByUrl(NAVIGATIONURLS.confirmEmail());
	}
	async map() {
		await this.router.navigateByUrl(NAVIGATIONURLS.map());
	}
	async settings() {
		await this.router.navigateByUrl(NAVIGATIONURLS.settings());
	}
	async navigateToUrl(url: string) {
		await this.router.navigateByUrl(url);
	}
	async foodSpot() {
		await this.router.navigateByUrl(NAVIGATIONURLS.foodSpot());
	}
	async navigateToUrlWithParams(url: string, queryParams: Params) {
		console.log(`${url}, queryParams: ${JSON.stringify(queryParams)}`);
		this.navCtrl.navigateForward(url, {
			queryParams,
		});
	}
	async navigateSelectOrderType() {
		await this.router.navigateByUrl(NAVIGATIONURLS.selectOrderType());
	}
	async navigateSelectedCategory(categoryId?: string) {
		let queryParams = {};
		if (categoryId) {
			queryParams = {
				categoryId,
			};
		}
		await this.router.navigate([NAVIGATIONURLS.selectCategory()], {
			queryParams,
		});
	}
	async promo() {
		await this.router.navigate([NAVIGATIONURLS.promo()], {
			replaceUrl: true,
		});
	}
}
